import { SearchResultsProps } from "../types";
import { ISearchItem } from "../../../../models/ISearchLessonResponse";
import classes from "../../../../utils/HTML/classes";

export const SearchResults = ({
  data,
  isLoading,
  selectedMicroLessons,
  onAddMicroLesson,
  onRemoveMicroLesson,
}: SearchResultsProps) => {
  const handleRowClick = (microLesson: ISearchItem) => {
    if (microLesson.disabled) {
      return;
    }

    if (selectedMicroLessons.includes(microLesson)) {
      onRemoveMicroLesson(microLesson);
    } else {
      onAddMicroLesson(microLesson);
    }
  };

  return (
    <div className="search-results-container">
      <div className="search-results-table">
        <div className="search-results-table-header">
          <div>Lesson Name</div>
          <div>Lesson ID</div>
          <div>Published Date</div>
          <div>Tags</div>
        </div>
        <div className="search-results-table-body">
          {isLoading ? (
            <div className="search-results-no-data">
              <div>Loading...</div>
            </div>
          ) : !data || data.length === 0 ? (
            <div className="search-results-no-data">
              <div>No results found</div>
            </div>
          ) : (
            data.map((item) => {
              const tags = item.tags?.map((tag) => tag.tagKey).join(", ");
              return (
                <div
                  className={classes("search-results-table-row", {
                    "search-results-table-row--disabled": !!item.disabled,
                  })}
                  key={item.lessonId}
                  onClick={() => handleRowClick(item)}
                >
                  <div className="search-results-table-row-name">
                    <input
                      readOnly
                      type="checkbox"
                      checked={selectedMicroLessons.includes(item)}
                      disabled={item.disabled}
                    />
                    {item.name}
                  </div>
                  <div>{item.lessonId}</div>
                  <div>{item.publishedDateUtc || "N/A"}</div>
                  <div>{tags ? tags : "N/A"}</div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};
